import React, { Component } from "react";
import axios from "axios";
import { v4 as uuid } from "uuid";
import Quiz from "./Quiz";
const config = require("../config.json");

export default class QuizAdmin extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    newQuiz: {
      quizName: "",
      question_da: "",
      question_en: "",
      answers: [], // {text: "Blue", correct: false}
      id: uuid(),
      points: "",
      info_en: "",
      info_da: "",
      amountOfAnswers: 0,
    },
    quizzes: [],
  };

  getAnswerList = (quiz) => {
    const answers = [];
    for (let i = 1; i <= quiz.amountOfAnswers; i++) {
      answers.push({
        text_en: quiz[`answer${i}_en`],
        text_da: quiz[`answer${i}_da`],
        correct: quiz[`answer${i}correct`] ? quiz[`answer${i}correct`] : false,
      });
    }

    return answers;
  };

  handleAddQuiz = async (quiz, event) => {
    event.preventDefault();
    try {
      const params = {
        id: quiz.id,
        quizName: quiz.quizName,
        points: parseInt(quiz.points),
        question_da: quiz.question_da,
        question_en: quiz.question_en,
        answers: this.getAnswerList(quiz),

        info_en: quiz.info_en,
        info_da: quiz.info_da,
        category: "Quiz",
      };
      await axios.post(`${config.api.invokeUrl}/quiz/${quiz.id}`, params);

      this.setState({
        quizzes: [...this.state.quizzes, this.state.newQuiz],
      });
      this.setState({
        newQuiz: {
          quizName: "",
          question_da: "",
          question_en: "",
          answers: [],
          id: uuid(),
          points: "",
          info_en: "",
          info_da: "",
          amountOfAnswers: 0,
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleUpdateQuiz = async (quiz) => {
    try {
      const params = {
        id: quiz.id,
        quizName: quiz.quizName,
        points: parseInt(quiz.points),
        question_en: quiz.question_en,
        question_da: quiz.question_da,
        answers: quiz.answers,
        info_en: quiz.info_en,
        info_da: quiz.info_da,
        category: "Quiz",
      };

      await axios.patch(`${config.api.invokeUrl}/quiz/${quiz.id}`, params);
    } catch (err) {
      console.log(err);
    }
    const updatedQuizzes = [...this.state.quizzes].filter(
      (c) => c.id !== quiz.id
    );
    updatedQuizzes.push(quiz);
    this.setState({ quizzes: updatedQuizzes });
  };

  handleDeleteQuiz = async (id, event) => {
    event.preventDefault();
    if (window.confirm("Er du sikker?")) {
      try {
        await axios.delete(`${config.api.invokeUrl}/quiz/${id}`);
      } catch (err) {
        console.log(err);
      }
      const updatedQuizzes = [...this.state.quizzes].filter(
        (quiz) => quiz.id !== id
      );
      this.setState({ quizzes: updatedQuizzes });
    }
  };

  fetchQuizzes = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/quiz`);
      const quizzes = res.data;
      console.log(quizzes);
      this.setState({ quizzes: quizzes });
    } catch (err) {
      console.log(err);
    }
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      newQuiz: {
        ...this.state.newQuiz,
        [name]: value,
      },
    });
  }

  componentDidMount = () => {
    this.fetchQuizzes();
  };

  render() {
    return (
      <>
        <p className="subtitle is-5">Tilføj og fjern quizzer</p>
        <br />
        <div className="columns is-multiline">
          <div className="column is-full">
            <form
              onSubmit={(event) =>
                this.handleAddQuiz(this.state.newQuiz, event)
              }
            >
              <div className="field">
                <div className="control">
                  <input
                    className="input is-medium"
                    name={"quizName"}
                    type="text"
                    placeholder="Indtast navn"
                    value={this.state.newQuiz.quizName}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  <input
                    className="input is-medium"
                    name={"question_da"}
                    type="text"
                    placeholder="Indtast spørgsmål (DANSK)"
                    value={this.state.newQuiz.question_da}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  <input
                    className="input is-medium"
                    name={"question_en"}
                    type="text"
                    placeholder="Indtast spørgsmål (ENGELSK)"
                    value={this.state.newQuiz.question_en}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  <input
                    className="input is-medium"
                    name={"info_da"}
                    type="text"
                    placeholder="Indtast info (DANSK)"
                    value={this.state.newQuiz.info_da}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  <input
                    className="input is-medium"
                    name={"info_en"}
                    type="text"
                    placeholder="Indtast info (ENGLESK)"
                    value={this.state.newQuiz.info_en}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  <input
                    className="input is-medium"
                    name={"points"}
                    type="text"
                    placeholder="Indtast point"
                    value={this.state.newQuiz.points}
                    onChange={this.handleInputChange}
                  />
                </div>

                <div className="control">
                  Antal svarmuligheder
                  <input
                    className="input is-medium"
                    name={"amountOfAnswers"}
                    type="number"
                    placeholder="Indtast antal svarmuligheder"
                    value={this.state.newQuiz.amountOfAnswers}
                    onChange={this.handleInputChange}
                  />
                </div>

                {Array.from(
                  { length: parseInt(this.state.newQuiz.amountOfAnswers) },
                  (_, index) => index + 1
                ).map((idx) => {
                  return (
                    <div key={`answer${idx}`}>
                      Svarmulighed {idx}
                      <div className="control">
                        <input
                          className="input is-medium"
                          name={`answer${idx}_da`}
                          type="text"
                          placeholder={`Indtast svarmulighed ${idx} (DANSK)`}
                          value={this.state.newQuiz[`answer${idx}_da`]}
                          onChange={this.handleInputChange}
                        />
                        <input
                          className="input is-medium"
                          name={`answer${idx}_en`}
                          type="text"
                          placeholder={`Indtast svarmulighed ${idx} (ENGELSK)`}
                          value={this.state.newQuiz[`answer${idx}_en`]}
                          onChange={this.handleInputChange}
                        />
                        <label
                          style={{ marginRight: "5px" }}
                          htmlFor={`answer${idx}correct`}
                        >
                          Korrekt
                        </label>
                        <input
                          type="checkbox"
                          id={`answer${idx}correct`}
                          name={`answer${idx}correct`}
                          value={this.state.newQuiz["answer" + idx + "correct"]}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                  );
                })}
                <div className="control">
                  <button type="submit" className="button is-primary is-medium">
                    Tilføj
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="column flex-wrap d-flex">
            {this.state.quizzes.map((quiz) => (
              <Quiz
                handleUpdateQuiz={this.handleUpdateQuiz}
                handleDeleteQuiz={this.handleDeleteQuiz}
                quiz={quiz}
                key={quiz.id}
                isAdmin={true}
              />
            ))}
          </div>
        </div>
      </>
    );
  }
}
